import ResponsiveImage from "../../responsive-image/ResponsiveImage";
import './ImageDisplay.css';
import React, { useState, useEffect } from 'react';
import image1 from './images/image1.jpg';
import image2 from './images/image2.jpg';
import image3 from './images/image3.jpg';
import image4 from './images/image4.jpg';

const images = [image1, image2, image3, image4];

const ImageDisplay = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length); // Cycle through images
        }, 6500); // Move every 6.5 seconds

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="image-display">
            <div
                className="image-slider"
                style={{
                    transform: `translateX(-${currentIndex * 100}%)`,
                    transition: 'transform 0.5s ease-in-out',
                }}
            >
                {images.map((image, index) => (
                    <ResponsiveImage sizes="100vw"
                        src={image}
                        loading={index === 0 ? "eager" : "lazy"}
                        alt={`Image ${index + 1}`}
                        className="slider-image"
                        key={index}
                    />
                ))}
            </div>
            <div className="image-title"></div>
        </div>
    );
};

export default ImageDisplay;
